import React, { useEffect, useState } from 'react'
import * as yup from 'yup';

import { Select } from 'antd';

import './styles.css';
import TipoOptions, { Notifiable, Notifications } from '@app/types/core.types';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { Visibility } from '../Visibility';
import { isArray } from 'lodash';

interface ITagComponentV2Props {
    buttonText: string;
    onChange: (value: string[]) => void;
    sizeTextTag?: number;
    validate?: (value: string[]) => Notifiable;
    isValidateEmail?: boolean;
    hasLoadSelect?: boolean;
    onLoadListSelect?: () => Promise<TipoOptions[]>;
    visible?: boolean;
}

export const TagComponentV2 = ({
    buttonText,
    onChange,
    validate,
    isValidateEmail = false,
    visible = true,
    hasLoadSelect = false,
    onLoadListSelect,
}: ITagComponentV2Props) => {

    const [loadTagOptions, setLoadTagOptions] = useState<TipoOptions[]>([]);
    const [errors, setErrors] = useState<Notifications[]>([]);

    const [listSelect, setListSelect] = useState<string[]>([]);

    let schemaEmailValidate = yup.object().shape({
        array: yup.array().of(yup.string().email()),
    });

    useEffect(() => {
        onLoadListSelect && onLoadListSelect()
            .then((data: TipoOptions[]) => {
                setLoadTagOptions(data);
            }).catch(e => console.log(e));
    }, []);

    useEffect(() => {
        onChange && onChange(listSelect);
    }, [listSelect]);

    const handleSelectChange = (values: string[]) => {
        setErrors([]);
        let newTags: string[] = [...values];


        //find not valid emails in values
        let notValidEmails = values.filter((item) => {
            return !yup.string().email().isValidSync(item);
        });

        if (notValidEmails.length > 0) {
            notValidEmails.map((item) => {
                //removendo do array
                newTags = newTags.filter((tag) => tag !== item);

                //buscando a tag e add na lista
                let findTag = loadTagOptions.find((tag) => tag.value === parseInt(item));
                if (findTag) {
                    newTags.push(findTag.text || '');
                }
            });
        }

        if (isArray(values)) {

            if (isValidateEmail) {
                schemaEmailValidate
                    .isValid({
                        array: newTags,
                    })
                    .then(function (valid) {
                        if (valid) {
                            setListSelect(newTags);
                        } else {
                            setErrors([{ message: 'Email inválido', property: 'error' }] as Notifications[]);
                        }
                    });
            }

            if (isObjNotEmpty(validate)) {
                const notifiable: Notifiable = validate && validate(newTags) || { valid: true };
                if (notifiable.valid) {
                    setListSelect(newTags);
                } else {
                    setErrors(notifiable.notifications || []);
                }
                return;
            }
        }
    };

    return (
        <Visibility
            visible={visible}
        >
            <Select
                showSearch
                mode="tags"
                style={{ width: "100%" }}
                placeholder={buttonText || "Adicionar tags"}
                onChange={handleSelectChange}
                value={listSelect}
                onFocus={() => {
                    setErrors([]);
                }}
            >
                {hasLoadSelect && loadTagOptions.length > 0 && loadTagOptions.map((item, idx) => (
                    <Select.Option key={item.value}>{item.text}</Select.Option>
                ))}
            </Select>
            {
                errors.map((error) => (
                    <span className="txt-danger">{error.message}</span>
                ))
            }
        </Visibility>
    )
}
